import { Component, EventEmitter, OnInit, OnChanges, Input, Output, ViewChild, ElementRef } from '@angular/core';
// [[PrimeNg]]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { ClientMarketplaceCartProductService } from '~services/collective/client/marketplace/cart/product/product.service';
import { CustomerWishlistService } from '~services/panel/client/marketplace/customer/wishlist/wishlist.service';
import { CustomerNoticeService } from '~services/panel/client/marketplace/customer/notice/notice.service';
// ]
@Component({
  selector: 'IncluceProductBuy',
  templateUrl: './component.html',
  styleUrls: ['./component.css'],
})
export class ThisComponent implements OnInit {
  @Input() cart: any;
  @Input() product: any;
  profile: any;
  messageProcess = false;
  messageIsError: any;
  displayModal: boolean;
  addToCartModal: boolean;

  constructor(
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    //
    private userService: CustomerUserService,
    public collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    public clientMarketplaceCartProductService: ClientMarketplaceCartProductService,
    public customerWishlistService: CustomerWishlistService,
    public customerNoticeService: CustomerNoticeService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.ipBuildEcommerceDependencies();
  }

  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
  }
  /**
   * on changes
   */
  ngOnChanges() {
    this.createComponent();
  }

  /**
   * Creates component
   */
  createComponent() {}

  /**
   * Gets cart
   */
  getCart() {
    /**
     * Cart
     *
     * Request inicial do CARRINHO para acompanhamento nas Páginas.
     */
    this.collectiveMarketplaceCartService.cart({ client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid }).subscribe((Cart: any) => {
      if (Cart != null) {
        this.collectiveMarketplaceCartService.setCart(Cart.data);
      }
    });
  }

  productAddedToCart: any;
  productHasBeenBought: any = false;
  /**
   * Clients marketplace cart product service create
   */
  clientMarketplaceCartProductServiceCreate() {
    this.messageProcess = true;
    this.addToCartModal = false;
    var _ = this.clientMarketplaceCartProductService.store({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
      client_marketplace_core_product_id: this.productAddedToCart.id,
      inventory_quantity: this.inventoryQuantity,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.productHasBeenBought = true;
          this.displayModal = true;
          this.getCart();
          this.messageProcess = false;
        },
        (err) => {
          this.messageProcess = false;
        }
      );
    }
  }

  inventoryQuantity: number = 1;
  clientMarketplaceCartProductQuantityPlus() {
    this.inventoryQuantity++;
  }

  clientMarketplaceCartProductQuantityMinus() {
    this.inventoryQuantity--;
  }

  clientMarketplaceCartProductQuantityChange($event: any) {
    this.inventoryQuantity = $event.target.value;
  }

  /**
   * Clients marketplace wishlist product service create
   */
  clientMarketplaceWishlistProductServiceCreate(id: any) {
    var _ = this.customerWishlistService.store({
      client_marketplace_core_product_id: id,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageService.add({ severity: 'success', detail: 'Produto adicionado a sua lista de desejos.' });
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.customerWishlistService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace notice product service create
   */
  clientMarketplaceNoticeProductServiceCreate(id: any) {
    if (this.profile == undefined) {
      this.messageService.add({ severity: 'error', detail: 'Faça login em sua conta para criar um aviso.' });
    }
    var _ = this.customerNoticeService.store({
      client_marketplace_core_product_id: id,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.messageService.add({ severity: 'success', detail: 'Você receberá um e-mail quando o produto ' + this.product.name + ' estiver disponível' });
        },
        (err) => {
          var errorThrow = this.customerNoticeService.error.throw(err);
          if (errorThrow.hasOwnProperty('errors')) {
            errorThrow.errors.forEach((erro) => {
              this.messageService.add({ severity: 'error', sticky: true, detail: erro });
            });
          }
        }
      );
    }
  }

  openAddToCartModal(product: any) {
    this.productAddedToCart = product;
    this.addToCartModal = true;
  }
}
